import { useMutation, UseQueryResult } from '@tanstack/react-query'
import { queryClient, QueryOptions, UseMutationResult, useResource, useResources } from '.'
import {
  create,
  fetch,
  get,
  WorkPeriodTag,
  WorkPeriodTagCreationPayload,
  WorkPeriodTagUpdatePayload,
  update,
} from '../api/work-period-tags'

export const workPeriodTagKeys = {
  create: ['work-period-tags', 'create'] as const,
  update: ['work-period-tags', 'update'] as const,
} as const

//Queries
export const useWorkPeriodTagQuery = (
  id?: string,
  options?: QueryOptions<WorkPeriodTag>,
): UseQueryResult<WorkPeriodTag, any> =>
  useResource<WorkPeriodTag>('work-period-tags', get, id, undefined, options)

export const useWorkPeriodTagsQuery = (
  filters?: any,
  options?: QueryOptions<WorkPeriodTag[]>,
): UseQueryResult<WorkPeriodTag[], any> =>
  useResources<WorkPeriodTag[], any>('work-period-tags', fetch, filters, options)

//Mutations
const onMutationSuccess = () => {
  queryClient.invalidateQueries(['work-period-tags'])
}

export const useCreateMutation = (): UseMutationResult<WorkPeriodTag, WorkPeriodTagCreationPayload> =>
  useMutation(create, { mutationKey: workPeriodTagKeys.create, onSuccess: onMutationSuccess })

export const useUpdateMutation = (): UseMutationResult<WorkPeriodTag, WorkPeriodTagUpdatePayload> =>
  useMutation(update, {
    mutationKey: workPeriodTagKeys.update,
    onSuccess: onMutationSuccess,
  })

export const invalidateWorkPeriodTagsQueries = (): void => {
  queryClient.invalidateQueries(['work-period-tags'])
}
